import 'arrive';
import $ from 'jquery';
import 'waypoints/lib/noframework.waypoints.min.js';

document.arrive('.block-background-scroll-parallax .slide-card', {existing: true}, function(){

    var $block = $(this);
    var $parent = $block.parent();
    var $containerImgBackground = $parent.find('.background-layer');
    
    new Waypoint({
        element: $block[0],
        handler: function(direction) {

            if(direction == 'down'){
                $containerImgBackground.find('.background-img').removeClass('active');
                $containerImgBackground.find('.background-layer-img-'+this.element.dataset.number).addClass('active');
            }

        },
        offset: '80%'
    });

    new Waypoint({
        element: $block[0],
        handler: function(direction) {

            if(direction == 'up'){
                $containerImgBackground.find('.background-img').removeClass('active');
                $containerImgBackground.find('.background-layer-img-'+this.element.dataset.number).addClass('active');
            }

        },
        offset: '-80%'
    });

});

document.arrive('.block-background-scroll-parallax', {existing: true}, function(){

    var $block = $(this);
    var $border = $block.find('.border-effect');
    var $fistSlideCard = $block.find('.slide-card[data-number="1"] .content');
    var $cntnt = $block.find('.content');
    var windowWidth = 0;

    var blockOffsetTop = $block[0].offsetTop;

    $(window).on('scroll', function (event) {
        windowWidth = $( window ).width();
        var percentage = ((blockOffsetTop) / $(window).scrollTop()) - 1;

        if(percentage < 0.3 && percentage > 0){

            percentage = ( windowWidth < 500 ? (windowWidth / 1000) : 1 ) * (percentage / 0.3);

            $border.find('.border-effect__border-top').css('transform','translate3d(0px, 0px, 0px) scale(1, '+ percentage +')');
            $border.find('.border-effect__border-bottom').css('transform','translate3d(0px, 0px, 0px) scale(1, '+ percentage +')');
            $border.find('.border-effect__border-left').css('transform','translate3d(0px, 0px, 0px) scale('+ percentage +', 1)');
            $border.find('.border-effect__border-right').css('transform','translate3d(0px, 0px, 0px) scale('+ percentage +', 1)');
        } else if(percentage < 0.3){
            $border.find('.border-effect__border-top').css('transform','translate3d(0px, 0px, 0px) scale(1, 0)');
            $border.find('.border-effect__border-bottom').css('transform','translate3d(0px, 0px, 0px) scale(1, 0)');
            $border.find('.border-effect__border-left').css('transform','translate3d(0px, 0px, 0px) scale(0, 1)');
            $border.find('.border-effect__border-right').css('transform','translate3d(0px, 0px, 0px) scale(0, 1)');
        } else if(percentage > 0){
            let fixedSize = windowWidth < 500 ? 0.3 : 1;

            $border.find('.border-effect__border-top').css('transform','translate3d(0px, 0px, 0px) scale(1, ' + fixedSize + ')');
            $border.find('.border-effect__border-bottom').css('transform','translate3d(0px, 0px, 0px) scale(1, ' + fixedSize + ')');
            $border.find('.border-effect__border-left').css('transform','translate3d(0px, 0px, 0px) scale(' + fixedSize + ', 1)');
            $border.find('.border-effect__border-right').css('transform','translate3d(0px, 0px, 0px) scale(' + fixedSize + ', 1)');
        }
        if(percentage < (windowWidth < 500 ? 0.1 : 0.3)) {
            $block.addClass('active')
        }
        else {
            $block.removeClass('active')
        }

        //
        //  Show title
        //
        percentage = ((blockOffsetTop) / $(window).scrollTop()) - 1;
        if(percentage < 1 && percentage > 0){
            $fistSlideCard.css('opacity', 1 - percentage*0.65);
        } else if(percentage < 1){
            $fistSlideCard.css('opacity', 1);
        } else if(percentage > 0){
            $fistSlideCard.css('opacity', 0);
        }

        if(windowWidth < 500) {
            if(percentage < 1 && percentage > 0){
                $cntnt.css('transform','scale('+ Math.max(0.8,((1 - percentage) * 0.8) + 0.2)+')');
            } else if(percentage < 1){
                $cntnt.css('transform','scale(1)');
            } else if(percentage > 0){
                $cntnt.css('transform','scale(0.2)');
            }
        }
    });

});